import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import './style/Map.css'; // Импортируйте стили

const center = [51.169392, 71.449074]; // Координаты Астаны

const Map = () => {
  return (
    <div className="map-container">
      <div className="map-content-1">
        <h1 className="map-heading">Наши магазины рядом с Вами</h1>
        <MapContainer center={center} zoom={13} className="map">
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          />
          <Marker position={center}>
            <Popup>
              Астана
            </Popup>
          </Marker>
        </MapContainer>
      </div>
    </div>
  );
}

export default Map;
